import { ReactNode, useEffect } from 'react'
import { useAppSelector } from '../../redux/hooks'
import { useNavigate } from 'react-router-dom'
import { GenericSpinner } from '../GenericSpinner/GenericSpinner'

interface SuperadminRouteProps {
    children?: ReactNode
}

export const SuperadminRoute = ({ children }: SuperadminRouteProps) => {
    const auth = useAppSelector(state => state.auth)
    const isSuperAdmin = auth.accessTokenPayload ? auth.accessTokenPayload['cognito:groups']?.includes('superadmin') : false
    const navigate = useNavigate()

    useEffect(() => {
        if (!auth.pending && !auth.data) {
            navigate('/auth/sign-in')
        }
        if (!auth.pending && !isSuperAdmin) {
            navigate('/')
        }
    }, [auth, isSuperAdmin, navigate])

    if (auth.pending) {
        return <GenericSpinner />
    }

    if (!auth.data) {
        return <GenericSpinner />
    }

    if (!isSuperAdmin) {
        return <GenericSpinner />
    }

    return children
}